function loadSideBar(mapConfig){
	var dfd = jQuery.Deferred();
	$.get("static/geocatweb/templates/sidebar.html",function(data){
		
		$("#mapviewer-floating-sidemenu").html(data);
		
		$('.section-title span').text(mapConfig.nomAplicacio);

		$('#edit').on('click',function(){
			$('#searchPanel').attr("style","display:none;");
			$('#einesPanel').attr("style","display:none;");
			$('#editPanel').attr("style","display:block;");
			$('#mapviewer-floating-sidemenu').attr("style","transform:translateX(0px)");
			$('#hideBar').attr("style","display:block;");
		});
		
		$('#search').on('click',function(){
			$('#searchPanel').attr("style","display:block;");
			$('#einesPanel').attr("style","display:none;");
			$('#editPanel').attr("style","display:none;");
			$('#mapviewer-floating-sidemenu').attr("style","transform:translateX(0px)");
			$('#hideBar').attr("style","display:block;");
		});

		$('#eines').on('click',function(){
			$('#searchPanel').attr("style","display:none;");
			$('#einesPanel').attr("style","display:block;");
			$('#editPanel').attr("style","display:none;");
			$('#mapviewer-floating-sidemenu').attr("style","transform:translateX(0px)");
			$('#hideBar').attr("style","display:block;");
		});

		$('#hideBar').on('click',function(){
			$('#mapviewer-floating-sidemenu').attr("style","transform:translateX(-270px)");
			$('#hideBar').attr("style","display:none;");
		});
		
		//edit panel
		$('#drawTools').on('click',function(){
			gestionarPanel( 'funcio_draw', 'drawTools');
			cierraPanels('editPanel', 'funcio_draw');
		});
		
		$('#dadesTools').on('click',function(){
			gestionarPanel( 'carregar_dades', 'dadesTools');
			cierraPanels('editPanel', 'carregar_dades');			
		});
		
		$('#estilsTools').on('click',function(){
			gestionarPanel( 'funcio_tematics', 'estilsTools');
			cierraPanels('editPanel', 'funcio_tematics');			
		});
		
		$('#operationTools').on('click',function(){
			gestionarPanel( 'funcio_SIG', 'operationTools');
			cierraPanels('editPanel', 'funcio_SIG');			
		});

		//eines panel
		$('#mapLayersSidebar').on('click',function(){
			gestionarPanel( 'map_layers_sidebar','mapLayersSidebar');		
			cierraPanels('einesPanel', 'map_layers_sidebar');
		});
		
		$('#mapLegendSidebar').on('click',function(){
			gestionarPanel( 'map_legend_sidebar','mapLegendSidebar');		
			cierraPanels('einesPanel', 'map_legend_sidebar');
		});

		$('#fonsTools').on('click',function(){
			gestionarPanel( 'funcio_fonsMapes', 'fonsTools');			
			cierraPanels('einesPanel', 'funcio_fonsMapes');
		});
		
		$('#exportTools').on('click',function(){
			gestionarPanel( 'export_tools','exportTools');		
			cierraPanels('einesPanel', 'export_tools');
		});		
			
		$('#2d3d').on('click',function(){
			if (!estatMapa3D) {
				$('#exportHeader').attr("style","display:none;");
				nou_canviaVista_3D_2D('3D');
			}
			else {
				$('#exportHeader').attr("style","display:block;");
				nou_canviaVista_3D_2D('2D');
			}
		});

		addExportTools($('#export_tools'));
		
		addLayerControl($('#map_layers_sidebar'), controlCapes, map);
		
		if (ctr_legend!==undefined) addLegendControl($('#map_legend_layers'), ctr_legend, map);
		
		$('#edit').click(); //para activar el menú de edición al entrar 

		dfd.resolve();
	});
	
	return dfd.promise();
}